// extracted by mini-css-extract-plugin
export default {"ScrollArea":"Swiper_ScrollArea__cg5L5","slider":"Swiper_slider__l9+Wr","noti":"Swiper_noti__abzwg","more":"Swiper_more__gcvMT"};